module.exports = __webpack_public_path__ + "img/btn02.b15b1e64.svg";